import { styled } from '@mui/material/styles';

const StyledButtonWrapper = styled('span')(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.DS_spacing(['md'])};
   + p{
      margin: ${theme.DS_spacing(['md'])} 0;
  }
   + :is(h1, h2, h3, h4, h5, h6) {
      margin-top: 0;
   }

  ${theme.breakpoints.up('md')} {
       margin-bottom: ${theme.DS_spacing(['xl'])};
     + p {
      margin: ${theme.DS_spacing(['lg'])} 0;
      }

    }
  `,
);

export { StyledButtonWrapper };
